import { useModal } from '@ebay/nice-modal-react';
import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Plus } from 'assets/icons/Plus.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import WorkspaceRoleCreateModal from '../WorkspaceRoleCreateModal/WorkspaceRoleCreateModal';

const CreateRoleSettingsCard = () => {
  const { t } = useTranslation();
  const { workspacePermissions } = useWorkspacesContext({ requireWorkspaceId: true });
  const { show: showCreateRoleModal } = useModal(WorkspaceRoleCreateModal);

  const canCreateRoles = workspacePermissions.adjustRoles;

  return (
    <SettingsCard>
      <SettingsCard.Content className="space-y-4 px-4">
        <div className="space-y-2">
          <div className="font-medium">{t('workspaces.roles')}</div>
          <div className="text-gray-80 font-light">{t('workspaces.create_role_explanation')}</div>
        </div>
        {canCreateRoles && (
          <Button
            variant="primary"
            size="sm"
            iconRight={{ icon: Plus, className: 'color-white stroke-current stroke-2' }}
            onClick={() => showCreateRoleModal()}
          >
            {t('workspaces.create_role')}
          </Button>
        )}
      </SettingsCard.Content>
    </SettingsCard>
  );
};

export default CreateRoleSettingsCard;
